import React, {useId} from 'react';
import {Checkbox, RadioButton} from '@taopix/taopix-design-system';
import {CheckboxAppearanceTypes} from '@taopix/taopix-design-system/dist/types/Components/Checkbox/Checkbox';
import {SelectionMode} from '../MediaGallery';

export type ThumbnailSelectorProps = {
  appearance: CheckboxAppearanceTypes;
  children: any;
  label?: string;
  onToggle: (...args: any[]) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  selectable?: boolean;
  selected: boolean;
  selectionMode: SelectionMode;
};

const ThumbnailSelector = ({
  appearance = 'checkbox',
  children,
  label = 'checkbox',
  onToggle,
  selectable = true,
  selected,
  selectionMode = SelectionMode.Multi,
  onKeyDown,
}: ThumbnailSelectorProps) => {
  const id = useId().replace(new RegExp(':', 'g'), '');

  const selectableComponentProps = {
    appearance: appearance,
    className: 'w-full h-full overflow-hidden',
    defaultChecked: selected,
    hideLabel: true,
    id: `imageCheckbox_${id}`,
    label: label,
    onChange: (checked, event) => {
      onToggle(checked);
    },
    onKeyDown: event => {
      onKeyDown && onKeyDown(event);
    },
  };

  // Prevent Enter/space working to select thumbnails, since this would display the image overlays which are useless.

  const selectableComponent =
    SelectionMode.Single === selectionMode ? (
      <RadioButton
        {...selectableComponentProps}
        groupName={'thumbnail-selector'}
        appearance={'checkbox' === appearance ? 'radio' : 'border'}
        value={id}
        onChange={event => onToggle(true)}
      />
    ) : (
      <Checkbox {...selectableComponentProps} />
    );

  return (
    <>
      {selectable ? (
        React.cloneElement(selectableComponent, {...selectableComponent.props}, children)
      ) : (
        <>{children}</>
      )}
    </>
  );
};

export default ThumbnailSelector;
